<template>
    <div>
        <iframe
            ref="frame"
            class="preview px-lg-3"
            @load="onFrameLoaded"
            @click="$emit('update:dialog', true)"
        >
        </iframe>
        <v-dialog
            v-model="dialog"
            fullscreen
        >
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title class="text-capitalize">{{ messageSubject }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$emit('update:dialog', false)"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <iframe
                ref="frame-show"
                style="height: 100%; background: white"
                @load="onDialogFrameLoaded"
            >
            </iframe>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            messageBody: {
                type: String,
                required: true,
            },
            messageSubject: {
                type: String,
                required: true,
            },
            dialog: Boolean,
        },
        methods: {
            onFrameLoaded: function () {
                const { frame } = this.$refs;

                frame.contentWindow.document.body.innerHTML = this.messageBody;
                frame.contentWindow.addEventListener('click', (e) => {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    this.$emit('update:dialog', true);
                }, true);
            },
            onDialogFrameLoaded: function () {
                const frameShow = this.$refs['frame-show'];
                frameShow.contentWindow.document.body.innerHTML = this.messageBody;
            },
        }
    };
</script>

<style scoped>
.preview {
    width: 100%;
    border: none;
    cursor: pointer;
    height: 100%;
}
</style>